<script>
export default {
  name: 'has-sorting',
  data () {
    return {
      initialSortingValues: {}
    };
  },
  beforeMount () {
    this.initialSortingValues = JSON.parse(JSON.stringify(this.sorting));
    this.loadSorting();
  },
  mounted () {
    this.$bus.$on('view-sorting-save', this.saveSorting);
    this.$bus.$on('view-sorting-reset', this.resetSorting);
  },
  methods: {
    loadSorting () {
      if (!localStorage.getItem('wedliny-crm-sorting')) {
        this.resetSorting();
        return;
      }
      let sortingData = JSON.parse(localStorage.getItem('wedliny-crm-sorting'));
      if (sortingData.view && sortingData.view === this.$route.path.replace(/^a-z0-9\-\//gmi, '')) {
        this.sorting = JSON.parse(JSON.stringify(sortingData.sorting));
      } else {
        this.resetSorting();
      }
    },
    saveSorting () {
      let sortingData = {
        view: this.$route.path.replace(/^a-z0-9\-\//gmi, ''),
        sorting: this.sorting
      };
      sortingData = JSON.stringify(sortingData);
      localStorage.setItem('wedliny-crm-sorting', sortingData);
    },
    resetSorting () {
      this.sorting = JSON.parse(JSON.stringify(this.initialSortingValues));
      this.saveSorting();
    }
  },
  beforeDestroy () {
    this.$bus.$off('view-sorting-save', this.saveSorting);
    this.$bus.$off('view-sorting-reset', this.saveSorting);
  }
};
</script>
